// BasePlayerAdapter.js
'use strict';
import { player as playerDebug } from '../resource/debug.js';
const adapterDebug = playerDebug.extend('log:PlayerAdapter');
const adapterError = playerDebug.extend('error:PlayerAdapter');

/** @abstract */
class BasePlayerAdapter {
  constructor() {
    /** @type {HTMLVideoElement|null} */
    this._videoElement = null;
    this._isDestroyed = false;
  }

  /** @protected */
  _log(method, message, data = {}) {
    adapterDebug(`${method} ${message}`, data);
  }

  /** @protected */
  _logError(method, error) {
    const errorCode = error?.code ? ` code=${error.code}` : '';
    const errorName = error?.name ? ` name=${error.name}` : '';
    adapterError(
      `${method} ERROR${errorCode}${errorName} | ${error?.message || String(error)}`,
      error
    );
  }

  /** @protected */
  _guardDestroyed() {
    if (this._isDestroyed) {
      throw new Error('Player has been destroyed');
    }
  }

  /** @private */
  _notImplemented(method) {
    throw new Error(`${method} must be implemented by subclass`);
  }

  async initialize() {
    this._notImplemented('initialize');
  }
  async load() {
    this._notImplemented('load');
  }
  async unload() {
    this._notImplemented('unload');
  }
  async destroy() {
    this._notImplemented('destroy');
  }

  async play() {
    this._notImplemented('play');
  }
  pause() {
    this._notImplemented('pause');
  }

  mute() {
    this._notImplemented('mute');
  }
  unmute() {
    this._notImplemented('unmute');
  }

  /** @returns {boolean} Default true (safe default to avoid unexpected sound) */
  isMuted() {
    return true;
  }

  seek() {
    this._notImplemented('seek');
  }
  setPlaybackRate() {
    this._notImplemented('setPlaybackRate');
  }

  /** @returns {number} seconds */
  getCurrentTime() {
    return 0;
  }
  /** @returns {number} seconds */
  getDuration() {
    return 0;
  }
  /** @returns {number} */
  getPlaybackRate() {
    return 1;
  }

  on() {
    this._notImplemented('on');
  }
  off() {
    this._notImplemented('off');
  }

  getVideoElement() {
    return this._videoElement;
  }
  getInternalPlayer() {
    return null;
  }
}

export default BasePlayerAdapter;
